<mat-menu #addAccount="matMenu" yPosition="below" xPosition="before" class="dropdown-menu-panel">
  <div  appClickOutside class="search-container">
    <form>
      <mat-form-field appearance="fill" style="margin: 12px; width: -webkit-fill-available" class="form_input file-search" id="myfield">
        <mat-icon style="color: #707070" matSuffix>search </mat-icon>
        <input
          style="position: relative;top: -6px;left: 4px;"
          #accountInput
          type="text"
          matInput
          aria-label="Number"
          [formControl]="associationForm"
          placeholder="{{ ('Search ' + action_type_config_list[this.currentStep].description )| truncateStrPipe : 48 }} "
          id="search_input"
          />
          {{ accountInput.focus() }}
        </mat-form-field>
        @if (searchList?.length == 0 || noMatchFound) {
          <p style="color: rgb(198, 193, 193); font-size: 15px; padding: 0 12px" >
            No results found
          </p>
        }
        @if (searchList?.length) {
          <div class="search-result-continer">
            @for (data of searchList; track data) {
              <div class="search-result-item" (click)="selectAssociatedUser($event, data)">
                <div style="display: flex" class="mrr-10px" matTooltip="{{ data?.form_name ? data?.form_name : data?.name }}">
                  @if (data.form_name && data.profile_image_url) {
                    <div class="form-image-container">
                      <img [src]="data.profile_image_url" alt="" />
                    </div>
                  }
                  @if (data.name && !data.profile_image_url) {
                    <div class="form-image-container">
                      <mat-icon style="font-size: 19px; padding: 4px 2px; color: #25508e; position: relative; left: 6px">check_circle</mat-icon>
                    </div>
                  }
                  <p style="margin: 12px 0px; width: 160px" class="dropdown-text1 text-truncate">
                    <strong>
                      {{ data.form_name | titlecase }}
                      {{ data.name | titlecase }}
                    </strong>
                  </p>
                </div>
                <p style="margin: 12px 0px; min-width: 90px" class="update-at-title text-truncate">
                  {{ data.type_template | titlecase }}
                </p>
              </div>
            }
          </div>
        }

      </form>
    </div>
  </mat-menu>
  <div class="flex flex-col h-[80vh]" >
    <section class="h-[90%] "   >
      <p  class="sm:mb-6 font-semibold text-xl" >
        Link<span class="font-weight-bold-blue" >  {{manageType}} </span> to <span class="font-weight-bold-blue" [matTooltip]="data?.form_name.length > 41 ? data.form_name : ''"> {{ data?.form_name | truncateStrPipe : 41 }} </span>
      </p>
      <div style="overflow: auto !important; height:auto !important; display: flex;flex-direction: column;justify-content: space-between"
        class="bg-[#fff] shadow-none mb-3 h-auto border rounded-xl border-solid border border-[#53565B38]  ">
        <div class="flex flex-column">
          <div  class="flex flex-row px-3 pt-3" >
            @for (reminder of action_type_config_list; track reminder; let i = $index) {
              <div class="h-1.5 w-14 rounded-[40px] mr-1"
                [ngClass]="{'bg-[#25508E]': i == currentStep  || reminder.status == 'complete', 'bg-[#7E9BD4]' : i < currentStep &&  reminder.status != 'complete','bg-[#DCDCDC]' : i > currentStep  &&  reminder.status != 'complete' }"  >
              </div>
            }
          </div>
        </div>
        @for (reminder of action_type_config_list; track reminder; let i = $index) {
          @if (i == currentStep) {
            <div class="flex flex-row justify-between">
              <p   class="px-3 pt-2 pb-2 sm:mb-0 text-sm font-bold">
                {{reminder.description}} {{associate_form_list.length ? '('+ associate_form_list.length +')': ''}}
              </p>
              <button
                class="border rounded border-solid w-48 border border-[#53565B38] mr-3"
                (click)="$event.stopPropagation()"
                mat-button
                style="display: flex;justify-content: space-between;color: #898F9E;min-width: 220px;"
                [matMenuTriggerFor]="addAccount"
                #menuOwnership="matMenuTrigger"
                [disableRipple]="true"
                (menuOpened)="(menuOwnership.menuOpen)"
                (menuClosed)="(menuOwnership.menuOpen)"
                >
                <span  class="material-icons" style="color: #25508e;">search</span>
                <span style="position: relative; left: 8px">Search {{action_type_config_list[this.currentStep].description | truncateStrPipe : 10}}</span>
              </button>
            </div>
          }
        }
        @for (reminder of action_type_config_list; track reminder; let i = $index) {
          @if (i == currentStep) {
            <div class="flex flex-row justify-between">
              @if (isOtherEnable) {
                <manage-associated-other-form [is_mx_btn_needed]="is_mx_btn_needed" [manageType]="manageType" [currentuserId]="currentuserId" [is_loading]="is_loading" (getUpdatedData)="getUpdatedData()" [action_type_config_list]="action_type_config_list" [currentStep]="currentStep" [associate_form_list]="associate_form_list" [data]="data" style="width: 100%;">
                </manage-associated-other-form>
              }
              @if (!isOtherEnable) {
                <manage-associated-form  [manageType]="manageType" [is_mx_btn_needed]="is_mx_btn_needed" [currentuserId]="currentuserId" [is_loading]="is_loading" (getUpdatedData)="getUpdatedData()" [action_type_config_list]="action_type_config_list" [currentStep]="currentStep" [associate_form_list]="associate_form_list" [data]="data" style="width: 100%;">
                </manage-associated-form>
              }
            </div>
          }
        }
        <div
          class=" bg-[#EBF0FA]  rounded-b-xl flex items-start justify-between px-6 h-12"
          >
          <div style="min-width: 140px;">
            @if (currentStep>0) {
              <button
                class=" h-5 w-auto mt-1.5  px-6 mb-0 leading-[0rem] app__btn--primary"
                type="submit"
            style="background: transparent;
            border: 1px solid;
            margin-top: 11px !important;
            font-weight: 600;
            color: #25508e;"
                (click)="previousContact()"
                >
                <span class="material-icons text-base ml-[4px] leading-[0rem]"> arrow_back</span> Previous
              </button>
            }

          </div>
          @if (( (associate_form_list?.length) ||   (isOtherEnable?   manageAssociatedOtherForm?.selectDOntAdd : manageAssociatedForm?.selectDOntAdd) )&& (action_type_config_list.length-1 != currentStep ) ) {
            <button
              (click)="nextContact()"
              style="margin-top: 11px !important;"
              class=" h-5 w-auto mt-1.5  px-6 mb-0 leading-[0rem] app__btn--primary"
              type="submit"
              >
              Next  <span class="material-icons text-base ml-[4px] leading-[0rem]"> arrow_right_alt</span>
            </button>
          }
        </div>
      </div>

    </section>
    <mat-divider class="mt-6 pr-6"     ></mat-divider>
    <section class="h-[10%] pr-6 mt-3 flex justify-between"  >
      <div
        [class]="screenWidth >= 480? 'flex items-start justify-between pl-0 pr-0 w-full h-[65px]': 'flex items-start justify-between pl-0 pr-0 w-full h-[65px]'"
        >
        <button
          (click)="movetonext('backward')"
          class="bg-transparent cursor-pointer flex items-center font-bold text-xs gap-2" >
          <span  class="flex items-center gap-2 text-[#18191C]"
            ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
            >
          </button>
          <div
            class="w-[158px]"
            >
            @if (( (associate_form_list?.length) || (isOtherEnable?   manageAssociatedOtherForm?.selectDOntAdd :manageAssociatedForm?.selectDOntAdd ))&& (action_type_config_list.length-1 == currentStep ) ) {
              <button
                (click)="movetonext('forward')"
                class=" app__btn--primary mt-0 max-[480px]:items-center max-[480px]:h-[38px] max-[480px]:m-0"
                type="submit"
                >
                Continue
              </button>
            }
          </div>
        </div>
      </section>
    </div>